<template>
  <section id="contact">
    <div class="cmn-outer">
      <div class="cmn-inner">

        <h1 class="cmn-title">アルクへのお問い合せ</h1>
        <div class="cmn-footpring">
          <img src="../assets/img/img_footprint.png" alt="">
        </div>

        <div class="cmn-intro">
          ご相談、お見積り、<br>
          少しでもご興味・ご意見がございましたら、<br>
          お気軽にご相談ください。
        </div>

        <form @submit="checkForm">
          <table class="cmn-detail">
            <tr>
              <th>お名前</th>
              <td>
                <input type="text" name="name" placeholder="歩く 太郎" class="inputElm" v-model="name">
                <p class="confirmElm"></p>
                <p v-show="nameFlag" class="inputError" id="err_name">{{ nameStr }}</p>
              </td>
            </tr>
            <tr>
              <th>オナマエ<br>（フリガナ）</th>
              <td>
                <input type="text" name="name_kana" placeholder="アルク タロウ" class="inputElm" v-model="kana">
                <p class="confirmElm"></p>
                <p v-show="kanaFlag" class="inputError" id="err_name_kana">{{ kanaStr }}</p>
              </td>
            </tr>
            <tr>
              <th>メールアドレス</th>
              <td>
                <input type="text" name="mail" placeholder="tarou@arucu.co.jp" class="inputElm" v-model="mail">
                <p class="confirmElm"></p>
                <p v-show="mailFlag" class="inputError" id="err_mail">{{ mailStr }}</p>
              </td>
            </tr>
            <tr>
              <th>メールアドレス（確認用）</th>
              <td>
                <input type="text" name="mail_chk" placeholder="tarou@arucu.co.jp" class="inputElm" v-model="mailChk">
                <p class="confirmElm"></p>
                <p v-show="mailChkFlag" class="inputError" id="err_mail_chk">{{ mailChkStr }}</p>
              </td>
            </tr>
            <tr>
              <th>お問合せ内容</th>
              <td>
                <textarea class="inputElm" rows="5" name="infotext" v-model="info"></textarea>
                <p class="confirmElm"></p>
                <p v-show="infoFlag" class="inputError" id="err_infotext">{{ infoStr }}</p>
              </td>
            </tr>
          </table>
          <div class="formInfo">
            <strong>個人情報の取扱いについて</strong><br>
            本サイトでご提供いただきましたお客様の個人情報は、お問い合わせに回答させていただく目的で利用します。<br>
            こちらで入力された内容は、当社のプライバシーポリシーに基づき、適切に管理します。<br>
            個人情報の取り扱いに同意したとみなします。
          </div>
          <ul class="formButton">
            <li>
              <a href="javascript:void(0);" @click="resetForm">リセット</a>
            </li>
            <li>
              <a href="javascript:void(0);" @click="checkForm">確認</a>
            </li>
          </ul>
        </form>

      </div>
    </div>
    <aside v-bind:class="confirmFlag" class="confirm">
      <div class="confirm_inner">
        <p>この内容で送信しますか？</p>
        <ul>
          <li><a href="javascript:void(0);" class="confirm_inner-ok" @click="confirmOK">はい</a></li>
          <li><a href="javascript:void(0);" class="confirm_inner-ng" @click="confirmNG">いいえ</a></li>
        </ul>
      </div>
    </aside>
  </section>
</template>

<script>
export default {
  name: 'contact',
  mounted(){
    console.log("mounted:component");
  },
  data(){
    return {
      name: null,
      nameFlag: false,
      nameStr: "ご入力ください。",
      kana: null,
      kanaFlag: false,
      kanaStr: "ご入力ください。",
      mail: null,
      mailFlag: false,
      mailStr: "ご入力ください。",
      mailChk: null,
      mailChkFlag: false,
      mailChkStr: "ご入力ください。",
      info: null,
      infoFlag: false,
      infoStr: "ご入力ください。",
      confirmFlag: {
        isShow: false
      },
    }
  },
  methods: {
    checkForm(_e){
      _e.preventDefault();

      //名前
      if(!this.name){
        this.nameFlag = true;
      }else{
        this.nameFlag = false;
      }

      //フリガナ
      if(!this.kana){
        this.kanaFlag = true;
        this.kanaStr = "ご入力ください。";  
      }else if(!this.validKana(this.kana)){
        this.kanaFlag = true;
        this.kanaStr = "カタカナでご入力ください。";  
      }else{
        this.kanaFlag = false;
      }
      
      //メール
      if(!this.mail){
        this.mailFlag = true;
        this.mailStr = "ご入力ください。";  
      }else if(!this.validEmail(this.mail)){
        this.mailFlag = true;
        this.mailStr = "有効なメールアドレスをご入力ください。";  
      }else{
        this.mailFlag = false;
      }
      
      //メール確認
      if(!this.mailChk){
        this.mailChkFlag = true;
        this.mailChkStr = "ご入力ください。";  
      }else{
        if(this.mail === this.mailChk){
          this.mailChkFlag = false;       
        }else{
          this.mailChkFlag = true;
          this.mailChkStr = "メールアドレスをご確認ください。";  
        }
      }
      
      //問い合わせ内容
      if(!this.info){
        this.infoFlag = true;
      }else{
        this.infoFlag = false;
      }

      if(!this.nameFlag &&
        !this.kanaFlag &&
        !this.mailFlag &&
        !this.mailChkFlag &&
        !this.infoChk        
      ){
      //メール送信
        this.confirmFlag.isShow = true;
        // if(window.confirm("メールを送信してもよろしいでしょうか？")){
        //   this.requestForm();
        // }
        //$('.confirm').addClass('isShow');
        // this.confirmFlag = true;
        // $('.confirm_inner-ok').off().on('click', () => {
        //   this.requestForm();
        // });
        // $('.confirm_inner-ng').off().on('click', () => {
        //   $('.confirm').removeClass('isShow');
        // });
      }else{
      //バリデーションエラー
        window.scrollTo(0,0);
      }
    },
    validEmail: (_email) => {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(_email);
    },
    validKana: (_kana) => {
      let re = /^[ｱ-ﾝァ-ロワヲンー]*$/;
      return re.test(_kana);
    },
    resetForm(){
      this.name = null;
      this.nameFlag = false;
      this.kana = null;
      this.kanaFlag = false;
      this.mail = null;
      this.mailFlag = false;
      this.mailChk = null;
      this.mailChkFlag = false;
      this.info = null;
      this.infoFlag = false;
    },
    confirmOK(){
      this.requestForm();
      this.resetForm();
      this.confirmFlag.isShow = false;
    },
    confirmNG(){
      this.confirmFlag.isShow = false;
    },
    requestForm(){
      let path = '/sendmail.php';
      let method = 'POST';
      let tim = new Date();
      let data = "name_kanji=" + encodeURIComponent(this.name);
          data += "&name_kana=" + encodeURIComponent(this.kana);
          data += "&mailaddress=" + this.mail;
          data += "&body=" + encodeURIComponent(this.info);
          data += "&tim=" + tim.getSeconds()+tim.getMilliseconds();

      if(fetch){
      //fetch API
        fetch(path, {
          method: method,
          body: data,
          mode: 'cors',
          headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}
        }).then(function(response) {
          if(response.ok){
            return response.text();
          }else{
            console.log("error:1");
          }
        }).then(function(responseText) {
          console.log(responseText);
          if(responseText == '1'){
          //成功
            // alert("成功");
          }else{
            console.log("メール送信失敗しました。");
          }
        }).catch(function(e){
        //エラー
          console.log("error:2");
        });
      }else{
      //レガシー対応
        let createHttpRequest = () => {
          if(window.ActiveXObject){
            try {
              return new ActiveXObject("Msxml2.XMLHTTP")
            } catch (e) {
              try {
                return new ActiveXObject("Microsoft.XMLHTTP")
              } catch (e2) {
                return null
              }
            }
          } else if(window.XMLHttpRequest){
            return new XMLHttpRequest()
          } else {
            return null
          }
        }

        let httpoj = createHttpRequest();
        httpoj.open( method , path , true );
        httpoj.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded'); 
        httpoj.onreadystatechange = function(){ 
          if((httpoj.readyState == 4) && (httpoj.status == 200)){
            if(httpoj.responseText == "1"){
              alert("成功");
            }else{
              console.log("メール送信失敗しました。");
            }
          }else{
            console.log("error:3");
          }
        }
        httpoj.send( data );
      }
    }
  }
}
</script>


<style lang="scss" scoped>
#contact{
  form {
    .inputError{
      color: red;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/contact.vue